<template>
  <div class="car-content car-main-tab-content car-reduced-width" data-js="region-selection">
    <back-btn />

    <div class="car-selection-overview">
      <selected-vehicle-tile />
    </div>

    <div class="car-form-container car-region-selection">
      <div class="car-content-introduction">
        <span class="car-headline">
          {{$t('regionselection.title')}}
        </span>
        <p>{{$t('regionselection.description')}}</p>
      </div>
      <div class="car-form-item car-form-item-region">
        <label>{{$t('regionselection.regionLabel')}}</label>
        <region-search :region="region" @onRegionSelection="selectRegion" />
      </div>
      <div class="car-form-buttons car-buttons">
        <primary-btn @click="goToServiceSelection"
                     v-if="region"
                     data-js="region-selection--btn"
                     class="car-btn-primary">
          {{ $t('regionselection.mainBtn') }}
        </primary-btn>
      </div>
    </div>
  </div>
</template>

<script>
import BackBtn from '@/components/BackBtn';
import PrimaryBtn from '@/components/PrimaryBtn';
import SelectedVehicleTile from '@/components/vehicleIdentification/SelectedVehicleTile';

export default {
  name: 'RegionSelection',
  data() {
    return {
      region: this.$store.getters['region/selectedRegion']
        ? (this.$store.getters['region/selectedRegion'].id ? this.$store.getters['region/selectedRegion'] : null) : null
    }
  },
  components: {
    PrimaryBtn,
    BackBtn,
    SelectedVehicleTile
  },
  methods: {
    selectRegion(region) {
      this.region = region;
      this.$store.dispatch('region/setRegion', region);
      // this.goToServiceSelection();
    },
    goToServiceSelection() {
      if (this.region) {
        this.$router.push({ name: 'ServiceSelection' });
      }
    }
  }
}
</script>
